<template>
  <div class="app">
	<div class="content">
		<van-empty v-if="list.length == 0" description="暂无数据" />
		<div v-else>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
					<zylxCard :list="list"></zylxCard>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import zylxCard from '../common/zylx-card'
import { Toast,Picker } from 'vant'
export default {
	components:{zylxCard},
	data(){
		return{
			text:"/hmhq/wallDetail",
			list:[],
			loading: false,
			finished: false,
			refreshing: false,
			pageNo:0,
			finishedTxt:""
		}
	},
	mounted() {
		this.onRefresh();
	},
	methods:{
		init(){
			let openId = this.$store.getters.openId;
      		let params = {pageNo:this.pageNo,openId:openId};
			getAction('/zhshj/rclmrczj/page',params)
			.then((res)=>{
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
                }
				this.loading = false;
				let data = res.result.records
				data.map((item,index)=>{
					if(item.imgUrl){
						item.user = item.imgUrl.split(',')[0]
					}else{
						item.user = require("@images/banner/user.jpg")
					}
				})
				console.log("res",data);
				this.list = this.list.concat(data)
				if(res.result.pages <= this.pageNo){
					this.finished = true;
					if(this.pageNo!=1){
						this.finishedTxt = "暂无更多了"
					}
				}
			})
		},
		onLoad(){
			this.pageNo++
			console.log("加载",this.pageNo);
			this.init();
		},
		onRefresh() {
			// 清空列表数据
			this.finished = false;
			this.finishedTxt = ""
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.pageNo = 0;
			this.refreshing  = true;
			this.onLoad();
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	min-height: 100vh;
	background-color: white;
}
p{
	margin: 0px;
	padding: 0px;
}
h3{
	margin: 0px;
}
input{
	border: none
}
.content{
	padding: 0px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		// height: 100px;
		border-radius: 4px;
		background: white;
		padding: 10px 0px;
		border-bottom: 1px solid #F4F4F4;
		&-card{
			padding: 10px 10px;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				display: flex;
				justify-content: center;
				img{
					height: 100%;
					border-radius: 50%;
				}
			}
			>div:last-child{
				width: 74%;
				height: 100%;
				margin: 4px 0px;
				h3{
					
				}
				p{
					font-size: 16px;
					color: #666666;
					margin: 4px 0px;
				}
				.bq{	
					display: flex;
					flex-wrap: wrap;
					span{
						font-size: 14px;
						color:#9D9D9D;
						background: #F3F3F4;
						border-radius: 4px;
						padding: 2px 4px;
						margin: 0px 4px 8px 0px;
					}
					span:last-child{
						margin: 0px 0px 8px 0px;
					}
				}
			}
		}
	}
}
</style>